// extracted by mini-css-extract-plugin
export var content = "_5t-3";
export var list = "_5t-4";
export var settingsContent = "_5t-7";
export var settingsPanel = "_5t-8";
export var state = "_5t-6";
export var triggerBadge = "_5t-2";
export var triggerButton = "_5t-1";
export var triggerShell = "_5t-0";
export var unreadDot = "_5t-5";